/** @format */
import axios, { InternalAxiosRequestConfig } from "axios";

export const Request = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL ?? "/api",
  timeout: 30000,
});

// REQUEST INTERCEPTOR (type-safe & FormData-safe)
Request.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("access_token");

    // Axios v1: headers is AxiosHeaders (has set/get/has/delete)
    const h = config.headers as any;

    if (token) {
      if (typeof h.set === "function") {
        h.set("Authorization", `Bearer ${token}`);
      } else {
        h["Authorization"] = `Bearer ${token}`;
      }
    }

    // If sending FormData, LET BROWSER SET BOUNDARY -> remove any content-type
    const isForm =
      typeof FormData !== "undefined" && config.data instanceof FormData;

    if (isForm) {
      if (typeof h.delete === "function") {
        h.delete("Content-Type");
        h.delete("content-type");
      } else {
        delete h["Content-Type"];
        delete h["content-type"];
      }
    } else {
      // For non-FormData, default to JSON if not already set
      if (typeof h.has === "function") {
        if (!h.has("Content-Type")) h.set("Content-Type", "application/json");
      } else if (!h["Content-Type"] && !h["content-type"]) {
        h["Content-Type"] = "application/json";
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);
